import React, { useState } from 'react';
import OverviewHeader from './header';
import Statistics from './statistics';
import { ENUM_DATE_RANGE, getDateRangeSelector } from '@cokitchen/cokitchen-components';
import { OverviewFilterType } from './types';
import { CoKitchenPolygons } from 'models/cokitchen.model';

const OverviewTopStatistics = () => {
  const [filters, setFilters] = useState<OverviewFilterType>({
    activePolygon: {} as CoKitchenPolygons,
    dateRange: {
      range: ENUM_DATE_RANGE.THIS_WEEK,
      date: getDateRangeSelector(ENUM_DATE_RANGE.THIS_WEEK)
    }
  });

  return (
    <div className='flex flex-col gap-y-10 mb-6'>
      <OverviewHeader value={filters} onChange={setFilters} />
      <Statistics filters={filters} />
    </div>
  );
};

export default OverviewTopStatistics;
